<template>
  <div id="app">

    <router-view/>

<!-- <UpdatePage></UpdatePage> -->
  </div>
</template>

<script>

import UpdatePage from '@/manage/UpdatePage'
export default {
  name: 'App',
  components:{UpdatePage}
}
</script>

<style>
/* @import url("./css/weui.css"); */
/*  @import url("./css/weuix.css"); */
  @import url("./css/weuima.css");
body{

  margin: 0;
  padding: 0;
user-select: none;
}
#app{
	position: relative;
  margin: 0 auto;
  padding: 0;
 -webkit-tap-highlight-color:transparent;
  max-width: 540px;
  min-width: 320px;
  background-color: #dddddd;
  min-height: 100vh;
  font-size: 16px;
}
</style>



// WEBPACK FOOTER //
// src/App.vue